import React from "react";
import { pdf } from "@react-pdf/renderer";
import WizardQuestionsPDF from "../components/WizardQuestionsPDF";

// Blob -> <a download> mechanics, shared by every file the app hands the user.
//
// `revokeDelayMs` exists because revoking the object URL in the same tick as the
// click cancels the download in some browsers. The wizard PDFs have always
// revoked immediately and are known to work, so that stays the default; the MW
// export opts into a delay.
export const downloadBlob = (blob, filename, { revokeDelayMs = 0 } = {}) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  if (revokeDelayMs > 0) {
    setTimeout(() => window.URL.revokeObjectURL(url), revokeDelayMs);
  } else {
    window.URL.revokeObjectURL(url);
  }
};

// Generic @react-pdf/renderer element -> blob -> <a download> mechanics,
// shared by every product's wizard-PDF export (CSR's downloadWizardQuestionsPDF
// below, Patient Narrative's downloadPatientNarrativeWizardQuestionsPDF in
// File.js). Only the PDF content component and filename differ per product -
// this is the one piece that was previously duplicated between them.
export const downloadPdfElement = async (pdfElement, filename) => {
  try {
    const blob = await pdf(pdfElement).toBlob();
    downloadBlob(blob, filename);
  } catch (error) {
    console.error("Error generating PDF:", error);
    throw error;
  }
};

export const downloadWizardQuestionsPDF = questionsData =>
  downloadPdfElement(
    <WizardQuestionsPDF questionsData={questionsData} />,
    "Wizard_Questions_Answers.pdf"
  );
